import { UNIFIED_PAYLOAD as P } from '../data/unifiedPayload.js'
import { useState, useMemo } from 'react'

const LS = {
  get: (k, d) => { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : d } catch { return d } },
  set: (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)) } catch { /* 忽略 */ } },
}

const PRIO = { P0: '#dc2626', P1: '#ea580c', P2: '#2563eb' }
const catColor = (name, i) => {
  const H = ['#2563eb', '#0891b2', '#7c3aed', '#db2777', '#ea580c', '#059669', '#4f46e5', '#c026d3']
  let h = 0; for (const c of String(name)) h = (h * 31 + c.charCodeAt(0)) >>> 0
  return H[h % H.length] || (i % 2 ? '#0891b2' : '#2563eb')
}

/* ---------- 图标（内联 SVG，离线可用） ---------- */
const Ic = ({ d, s = 15, c = 'currentColor' }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c}
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d={d} /></svg>
)
const I_TASK = 'M9 11l3 3L22 4M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11'
const I_PROJ = 'M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z'
const I_IDEA = 'M9 18h6M10 22h4M12 2a7 7 0 0 0-4 12.7V17h8v-2.3A7 7 0 0 0 12 2z'
const I_BOX = 'M21 16V8a2 2 0 0 0-1-1.7l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.7l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z'
const I_TREE = 'M4 3h16v18H4zM4 9h16M4 15h16M9 3v18'
const I_SYNC = 'M21 2v6h-6M3 22v-6h6M21 8a9 9 0 0 0-15-3.4L3 8M3 16a9 9 0 0 0 15 3.4L21 16'

/* ---------- 商品中心 ---------- */
function ProductCenter() {
  const [q, setQ] = useState('')
  const [cat, setCat] = useState('')
  const [page, setPage] = useState(0)
  const SIZE = 30
  const list = useMemo(() => {
    const kw = q.trim().toLowerCase()
    return P.products.filter(p => {
      if (cat && p.newCategory !== cat) return false
      if (kw && !(p.name || '').toLowerCase().includes(kw) && !(p.sku || '').toLowerCase().includes(kw)) return false
      return true
    })
  }, [q, cat])
  const pages = Math.max(1, Math.ceil(list.length / SIZE))
  const cur = Math.min(page, pages - 1)
  return <>
    <div className="bar">
      <input className="inp" placeholder="搜索商品名称 / SKU…" value={q}
        onChange={e => { setQ(e.target.value); setPage(0) }} />
      <select className="inp" value={cat} onChange={e => { setCat(e.target.value); setPage(0) }}>
        <option value="">全部分类（{P.categories.length}）</option>
        {P.categories.map(c => <option key={c.name} value={c.name}>{c.name}（{c.count}）</option>)}
      </select>
      <span className="cnt">命中 <b>{list.length}</b> / {P.products.length}</span>
    </div>
    <table className="tb">
      <thead><tr><th>ID</th><th>SKU</th><th>商品名称</th><th>新分类</th><th>方式</th></tr></thead>
      <tbody>
        {list.slice(cur * SIZE, cur * SIZE + SIZE).map(p => <tr key={p.id}>
          <td className="mono">{p.id}</td>
          <td className="mono sm">{p.sku}</td>
          <td className="nm">{p.name}</td>
          <td><span className="tag" style={{ background: catColor(p.newCategory) + '1a', color: catColor(p.newCategory) }}>
            {p.newCategory || '未分类'}</span></td>
          <td><span className="mt" data-m={p.method}>{p.method}</span></td>
        </tr>)}
      </tbody>
    </table>
    {pages > 1 && <div className="pager">
      <button disabled={cur === 0} onClick={() => setPage(0)}>« 首页</button>
      <button disabled={cur === 0} onClick={() => setPage(cur - 1)}>‹ 上一页</button>
      <span className="mono">第 {cur + 1} / {pages} 页</span>
      <button disabled={cur >= pages - 1} onClick={() => setPage(cur + 1)}>下一页 ›</button>
      <button disabled={cur >= pages - 1} onClick={() => setPage(pages - 1)}>末页 »</button>
    </div>}
  </>
}

function Categories() {
  const max = Math.max(...P.categories.map(c => c.count))
  const total = P.categories.reduce((s, c) => s + c.count, 0)
  return <>
    <div className="bar"><span className="cnt">共 <b>{P.categories.length}</b> 个一级分类 · <b>{total}</b> 件商品</span></div>
    <div className="bars">
      {P.categories.map((c, i) => <div className="brow" key={c.name}>
        <div className="blab">{c.name}</div>
        <div className="btrack"><div className="bfill" style={{
          width: (c.count / max * 100).toFixed(1) + '%', background: catColor(c.name, i)
        }} /></div>
        <div className="bval mono">{c.count}<span className="pct">（{(c.count / total * 100).toFixed(1)}%）</span></div>
      </div>)}
    </div>
  </>
}

function SyncInfo() {
  const s = P.stats
  const md = Object.entries(s.methodDistribution || {}).sort((a, b) => b[1] - a[1])
  const ld = Object.entries(s.levelDistribution || {}).sort()
  return <>
    <div className="kv"><span>数据生成时间</span><b>{P.generatedAt}</b></div>
    <div className="kv"><span>商品总数</span><b>{s.total?.toLocaleString()}</b></div>
    <div className="kv"><span>一级分类</span><b>{s.categoryCount}</b></div>
    <div className="kv"><span>Sellfox 类目节点</span><b>{s.sellfoxCategoryNodes}</b></div>
    <div className="kv"><span>最大层级深度</span><b>{s.sellfoxCategoryMaxDepth}</b></div>
    <div className="kv"><span>已分配 / 未分配</span><b>{s.assigned} / {s.unassigned}</b></div>
    <div className="kv"><span>服装类商品</span><b>{(s.clothingTotal || 0).toLocaleString()}</b></div>
    <div className="kv"><span>CID 全量匹配</span><b>{s.sellfoxFullCidMatched?.toLocaleString()}</b></div>
    <h4>分类方式分布</h4>
    <table className="tb sm2"><thead><tr><th>方式</th><th>数量</th><th>占比</th></tr></thead>
      <tbody>{md.map(([k, v]) => <tr key={k}><td><span className="mt" data-m={k}>{k}</span></td>
        <td className="mono">{v}</td><td className="mono">{(v / s.total * 100).toFixed(1)}%</td></tr>)}</tbody></table>
    <h4>层级分布</h4>
    <table className="tb sm2"><thead><tr><th>层级</th><th>商品数</th></tr></thead>
      <tbody>{ld.map(([k, v]) => <tr key={k}><td className="mono">L{k}</td><td className="mono">{v}</td></tr>)}</tbody></table>
  </>
}

/* ---------- 办公：任务（借鉴个人工作台：可增删改+本地持久化） ---------- */
function Tasks({ initProj = '' }) {
  const [ts, setTs] = useState(() => LS.get('fh_tasks', P.office.tasks))
  const [f, setF] = useState({ q: '', p: '', pf: false, proj: initProj })
  const [ed, setEd] = useState(null)
  const save = v => { setTs(v); LS.set('fh_tasks', v) }
  const list = ts.filter(t =>
    (!f.q || (t.title || '').toLowerCase().includes(f.q.toLowerCase())) &&
    (!f.p || t.priority === f.p) &&
    (!f.proj || t.project === f.proj) &&
    (!f.pf || !t.done))
  const today = new Date().toISOString().slice(0, 10)
  return <>
    <div className="bar">
      <input className="inp" placeholder="搜索任务…" value={f.q} onChange={e => setF({ ...f, q: e.target.value })} />
      <select className="inp" value={f.p} onChange={e => setF({ ...f, p: e.target.value })}>
        <option value="">全部优先级</option><option>P0</option><option>P1</option><option>P2</option>
      </select>
      <label className="chk"><input type="checkbox" checked={f.pf}
        onChange={e => setF({ ...f, pf: e.target.checked })} />只看待办</label>
      <button className="btn pri" onClick={() => setEd({ id: '', title: '', priority: 'P1', due: today, project: '', done: false })}>
        <Ic d={I_TASK} /> 新增任务
      </button>
    </div>
    <div className="kv"><span>总计 / 待办 / 逾期</span>
      <b>{ts.length} / {ts.filter(t => !t.done).length} / {ts.filter(t => !t.done && t.due && t.due < today).length}</b></div>
    <table className="tb">
      <thead><tr><th>状态</th><th>优先级</th><th>任务</th><th>所属项目</th><th>截止</th><th>操作</th></tr></thead>
      <tbody>
        {list.map(t => <tr key={t.id} className={t.done ? 'dn' : ''}>
          <td><input type="checkbox" checked={!!t.done}
            onChange={e => save(ts.map(x => x.id === t.id ? { ...x, done: e.target.checked } : x))} /></td>
          <td><span className="pri" style={{ background: PRIO[t.priority] }}>{t.priority}</span></td>
          <td className="nm">{t.title}</td>
          <td className="sm">{t.project || '—'}</td>
          <td className="mono sm">{t.due || '—'}{!t.done && t.due && t.due < today && <span className="od">逾期</span>}</td>
          <td className="ops">
            <button onClick={() => setEd(t)}>编辑</button>
            <button className="dl" onClick={() => save(ts.filter(x => x.id !== t.id))}>删除</button>
          </td>
        </tr>)}
        {!list.length && <tr><td colSpan="6" className="empty">暂无匹配任务</td></tr>}
      </tbody>
    </table>
    {ed && <Modal title={ed.id ? '编辑任务' : '新增任务'} onClose={() => setEd(null)}>
      <label>任务名称<input className="inp" value={ed.title} autoFocus
        onChange={e => setEd({ ...ed, title: e.target.value })} /></label>
      <div className="two">
        <label>优先级<select className="inp" value={ed.priority}
          onChange={e => setEd({ ...ed, priority: e.target.value })}>
          <option>P0</option><option>P1</option><option>P2</option></select></label>
        <label>截止日期<input className="inp" type="date" value={ed.due}
          onChange={e => setEd({ ...ed, due: e.target.value })} /></label>
      </div>
      <label>所属项目<input className="inp" value={ed.project}
        onChange={e => setEd({ ...ed, project: e.target.value })} /></label>
      <div className="mact">
        <button className="btn pri" onClick={() => {
          if (!ed.title.trim()) return
          save(ed.id ? ts.map(x => x.id === ed.id ? ed : x)
            : [...ts, { ...ed, id: 'T' + Date.now(), created: today }])
          setEd(null)
        }}>保存</button>
        <button className="btn" onClick={() => setEd(null)}>取消</button>
      </div>
    </Modal>}
  </>
}

/* ---------- 项目 ---------- */
function Projects({ onGoTask }) {
  const [ps, setPs] = useState(() => LS.get('fh_projects', P.office.projects))
  const save = v => { setPs(v); LS.set('fh_projects', v) }
  return <>
    <div className="bar"><span className="cnt">共 <b>{ps.length}</b> 个项目 · 点击「查任务」跳到任务页并自动筛选</span></div>
    <div className="cards">
      {ps.map((p, i) => <div className="card" key={p.name}>
        <div className="ch"><span className="dot" style={{ background: catColor(p.name, i) }} /><b>{p.name}</b>
          <span className="stg">{p.stage}</span></div>
        <div className="cl"><span>下一步</span><p>{p.next}</p></div>
        <div className="cl"><span>卡点</span><p className={p.block && p.block !== '无' ? 'bad' : ''}>{p.block || '无'}</p></div>
        <div className="cf">
          <button className="btn" onClick={() => onGoTask(p.name)}><Ic d={I_TASK} /> 查任务</button>
          <button className="btn" onClick={() => save(ps.filter(x => x.name !== p.name))}>删除</button>
        </div>
      </div>)}
    </div>
  </>
}

/* ---------- 灵感 ---------- */
function Ideas() {
  const [is, setIs] = useState(() => LS.get('fh_ideas', P.office.ideas))
  const [t, setT] = useState('')
  const save = v => { setIs(v); LS.set('fh_ideas', v) }
  const today = new Date().toISOString().slice(0, 10)
  return <>
    <div className="bar">
      <input className="inp" placeholder="随手记一条想法…" value={t}
        onChange={e => setT(e.target.value)}
        onKeyDown={e => { if (e.key === 'Enter' && t.trim()) { save([{ date: today, content: t.trim(), tag: '速记', note: '' }, ...is]); setT('') } }} />
      <button className="btn pri" onClick={() => { if (!t.trim()) return; save([{ date: today, content: t.trim(), tag: '速记', note: '' }, ...is]); setT('') }}>
        <Ic d={I_IDEA} /> 记下来
      </button>
      <span className="cnt">共 <b>{is.length}</b> 条</span>
    </div>
    <div className="ideas">
      {is.map((x, i) => <div className="idea" key={i}>
        <div className="idate mono">{x.date}</div>
        <div className="ibody"><p>{x.content}</p>
          <div className="imeta"><span className="tag2">{x.tag}</span>{x.note && <span className="inote">{x.note}</span>}
            <button className="dl" onClick={() => save(is.filter((_, j) => j !== i))}>删除</button></div>
        </div>
      </div>)}
      {!is.length && <div className="empty">还没有灵感，记一条吧</div>}
    </div>
  </>
}

function Modal({ title, children, onClose }) {
  return <div className="mask" onClick={onClose}>
    <div className="modal" onClick={e => e.stopPropagation()}>
      <div className="mh">{title}<button className="x" onClick={onClose}>×</button></div>
      <div className="mb">{children}</div>
    </div>
  </div>
}

/* ---------- 概览 ---------- */
function Overview() {
  const s = P.stats
  const today = new Date().toISOString().slice(0, 10)
  const ts = LS.get('fh_tasks', P.office.tasks)
  const ps = LS.get('fh_projects', P.office.projects)
  const is = LS.get('fh_ideas', P.office.ideas)
  const max = Math.max(...P.categories.map(c => c.count))
  const top = [...P.categories].sort((a, b) => b.count - a.count).slice(0, 8)
  return <>
    <div className="kpis">
      <div className="kpi"><span>商品总数</span><b>{(s.total || 0).toLocaleString()}</b></div>
      <div className="kpi"><span>一级分类</span><b>{s.categoryCount}</b></div>
      <div className="kpi"><span>待办任务</span><b className="warn">{ts.filter(t => !t.done).length}</b></div>
      <div className="kpi"><span>逾期任务</span>
        <b className={ts.filter(t => !t.done && t.due && t.due < today).length ? 'bad' : ''}>
          {ts.filter(t => !t.done && t.due && t.due < today).length}</b></div>
      <div className="kpi"><span>进行中项目</span><b>{ps.length}</b></div>
      <div className="kpi"><span>灵感条数</span><b>{is.length}</b></div>
    </div>
    <div className="grid2">
      <div className="panel">
        <h3><Ic d={I_BOX} /> 分类 TOP 8</h3>
        {top.map((c, i) => <div className="brow" key={c.name}>
          <div className="blab">{c.name}</div>
          <div className="btrack"><div className="bfill" style={{ width: (c.count / max * 100) + '%', background: catColor(c.name, i) }} /></div>
          <div className="bval mono">{c.count}</div>
        </div>)}
      </div>
      <div className="panel">
        <h3><Ic d={I_TASK} /> 近期任务</h3>
        {ts.filter(t => !t.done).slice(0, 6).map(t => <div className="mini" key={t.id}>
          <span className="pri" style={{ background: PRIO[t.priority] }}>{t.priority}</span>
          <span className="mn">{t.title}</span>
          <span className="mono sm">{t.due || ''}</span>
        </div>)}
        <h3 style={{ marginTop: 16 }}><Ic d={I_PROJ} /> 项目状态</h3>
        {ps.map((p, i) => <div className="mini" key={p.name}>
          <span className="dot" style={{ background: catColor(p.name, i) }} />
          <span className="mn">{p.name}</span><span className="sm">{p.stage}</span>
        </div>)}
      </div>
    </div>
  </>
}

const MENU = [
  { k: 'ov', label: '总览', icon: I_BOX },
  { k: 'task', label: '任务', icon: I_TASK },
  { k: 'proj', label: '项目', icon: I_PROJ },
  { k: 'idea', label: '灵感', icon: I_IDEA },
  { k: 'prod', label: '商品总览', icon: I_BOX },
  { k: 'cat', label: '分类管理', icon: I_TREE },
  { k: 'sync', label: '数据同步', icon: I_SYNC },
]

export default function App() {
  const [tab, setTab] = useState('ov')
  const [taskProj, setTaskProj] = useState('')
  const s = P.stats
  const goTask = pn => { setTaskProj(pn); setTab('task') }
  const cur = MENU.find(m => m.k === tab)
  return <div className="app">
    <aside>
      <div className="brand"><Ic d={I_BOX} s={19} /><span>FullHaul<br /><i>统一工作台</i></span></div>
      <nav>{MENU.map(m => <button key={m.k} className={tab === m.k ? 'on' : ''}
        onClick={() => { setTab(m.k); setTaskProj('') }}><Ic d={m.icon} />{m.label}</button>)}</nav>
      <div className="foot">
        <div>商品 <b>{s.total?.toLocaleString()}</b></div>
        <div>分类 <b>{s.categoryCount}</b></div>
        <div className="mono">更新 {P.generatedAt?.slice(0, 10)}</div>
      </div>
    </aside>
    <main>
      <header>
        <h2>{cur?.label}</h2>
        {taskProj && tab === 'task' && <span className="flt">已筛选项目：<b>{taskProj}</b>
          <button onClick={() => setTaskProj('')}>清除</button></span>}
      </header>
      <div className="body">
        {tab === 'ov' && <Overview />}
        {tab === 'task' && <Tasks key={taskProj} initProj={taskProj} />}
        {tab === 'proj' && <Projects onGoTask={goTask} />}
        {tab === 'idea' && <Ideas />}
        {tab === 'prod' && <ProductCenter />}
        {tab === 'cat' && <Categories />}
        {tab === 'sync' && <SyncInfo />}
      </div>
    </main>
  </div>
}